'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _SnackbarBody = require('./SnackbarBody');

var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = (0, _jssThemeReactor.createStyleSheet)('Snackbar', function (theme) {
  return {
    root: {
      position: 'fixed',
      left: '50%',
      display: 'flex',
      bottom: 0,
      zIndex: theme.zIndex.snackbar,
      visibility: 'hidden',
      transform: 'translate(-50%, 100%)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.snackbar,
        easing: theme.transitions.easing.snackbar
      }) + ', ' + theme.transitions.create('visibility', {
        duration: theme.transitions.duration.snackbar,
        easing: theme.transitions.easing.snackbar
      })
    },
    open: {
      visibility: 'visible',
      transform: 'translate(-50%, 0)'
    }
  };
});

var Snackbar = (_temp2 = _class = function (_Component) {
  _inherits(Snackbar, _Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.clickAway = function () {
      if (_this.timerTransitionId) {
        // If transitioning, don't close the snackbar.
        return;
      }

      if (_this.props.open !== null && _this.props.onRequestClose) {
        _this.props.onRequestClose('clickaway');
      } else {
        _this.setState({ open: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Snackbar, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        this.setState({
          open: this.props.open,
          message: this.props.message,
          action: this.props.action
        });
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (this.state.open) {
          this.setAutoHideTimer();
          this.setTransitionTimer();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
          this.setState({
            open: false
          });

          clearTimeout(this.timerOneAtTheTimeId);
          this.timerOneAtTheTimeId = setTimeout(function () {
            _this2.setState({
              message: nextProps.message,
              action: nextProps.action,
              open: true
            });
          }, this.context.styleManager.theme.transitions.duration.snackbar);
        } else {
          var open = nextProps.open;

          this.setState({
            open: open !== null ? open : this.state.open,
            message: nextProps.message,
            action: nextProps.action
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        if (prevState.open !== this.state.open) {
          if (this.state.open) {
            this.setAutoHideTimer();
            this.setTransitionTimer();
          } else {
            clearTimeout(this.timerAutoHideId);
          }
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        clearTimeout(this.timerAutoHideId);
        clearTimeout(this.timerTransitionId);
        clearTimeout(this.timerOneAtTheTimeId);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'setAutoHideTimer',


    // Timer that controls delay before snackbar auto hides
    value: function () {
      function setAutoHideTimer() {
        var _this3 = this;

        var autoHideDuration = this.props.autoHideDuration;

        if (autoHideDuration > 0) {
          clearTimeout(this.timerAutoHideId);
          this.timerAutoHideId = setTimeout(function () {
            if (_this3.props.open !== null && _this3.props.onRequestClose) {
              _this3.props.onRequestClose('timeout');
            } else {
              _this3.setState({ open: false });
            }
          }, autoHideDuration);
        }
      }

      return setAutoHideTimer;
    }()

    // Timer that controls delay before click-away events are captured (based on when animation completes)

  }, {
    key: 'setTransitionTimer',
    value: function () {
      function setTransitionTimer() {
        var _this4 = this;

        this.timerTransitionId = setTimeout(function () {
          _this4.timerTransitionId = undefined;
        }, 400);
      }

      return setTransitionTimer;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            autoHideDuration = _props.autoHideDuration,
            contentClassName = _props.contentClassName,
            bodyClassName = _props.bodyClassName,
            classNameProp = _props.className,
            messageProp = _props.message,
            onRequestClose = _props.onRequestClose,
            onActionClick = _props.onActionClick,
            error = _props.error,
            other = _objectWithoutProperties(_props, ['autoHideDuration', 'contentClassName', 'bodyClassName', 'className', 'message', 'onRequestClose', 'onActionClick', 'error']);

        var _state = this.state,
            action = _state.action,
            message = _state.message,
            open = _state.open;


        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.open, open), classNameProp);
        /* eslint-disable */
        return _react2['default'].createElement(
          'div',
          _extends({}, other, {
            className: className,
            onClick: this.clickAway,
            'typeof': 'ui:Snackbar',
            role: 'button'
          }),
          _react2['default'].createElement(_SnackbarBody2['default'], {
            action: action,
            contentClass: contentClassName,
            message: message,
            open: open,
            onActionClick: onActionClick,
            className: bodyClassName,
            error: error
          })
        );
        /* eslint-enable */
      }

      return render;
    }()
  }]);

  return Snackbar;
}(_react.Component), _class.propTypes = {
  /**
   * The label for the action on the snackbar.
   */
  action: _PropTypes2['default'].node,
  /**
   * The number of milliseconds to wait before automatically dismissing.
   * If no value is specified the snackbar will dismiss normally.
   * If a value is provided the snackbar can still be dismissed normally.
   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
   */
  autoHideDuration: _PropTypes2['default'].number,
  /**
   * The css class name of the body element.
   */
  bodyClassName: _PropTypes2['default'].string,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The css class name of the content element.
   */
  contentClassName: _PropTypes2['default'].string,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _PropTypes2['default'].node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _PropTypes2['default'].func,
  /**
   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
   * `autoHideDuration` timer expires.
   *
   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
   * `open` prop.
   *
   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
   * for example ignoring `clickaway`.
   *
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _PropTypes2['default'].bool.isRequired,
  /**
   * Indicates the snackbar body should use the error color scheme
   */
  error: _PropTypes2['default'].bool
}, _class.defaultProps = {
  autoHideDuration: 4000
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
}, _temp2);


Snackbar.displayName = 'Snackbar';

exports['default'] = Snackbar;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Snackbar/Snackbar.js
// module id = 1860
// module chunks = 32